<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M23 3H9a2 2 0 00-2 2v22a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zM9 5h14v5H9zm0 22V12h14v15z"/><path d="M20.25 16h-6a1 1 0 000 2h6a1 1 0 000-2zM12.21 16.29a1 1 0 00-.91-.29l-.18.06a.76.76 0 00-.18.09 1.58 1.58 0 00-.15.12 1.15 1.15 0 00-.21.33.84.84 0 00-.08.38 1 1 0 101.92-.38 1 1 0 00-.21-.31zM20 21h-6a1 1 0 000 2h6a1 1 0 000-2zM10.54 21.29a1.05 1.05 0 00-.29.71 1 1 0 00.07.38 1.19 1.19 0 00.22.33 1 1 0 00.71.29 1 1 0 00.38-.08 1.15 1.15 0 00.33-.21 1 1 0 00.29-.71 1 1 0 00-1.71-.71z"/></svg>